/**
 * Created by Andrey Popov on 17.07.2025
 */

const Merge2SpeedUpTutorial = function () {
    return new TutorialScenario(Merge2SpeedUpTutorial.NAME, {
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused(["unitInfoView"], true);
        },

        listSteps: () => [
            new TutorialStep({
                onStart: function () {
                    const unitInfoView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).unitInfoView;

                    const unit = Merge2.current.field.listAvailableUnits({ type: "generator" })
                        .filter((u) => u.findComponent(Merge2Generator) && u.findComponent(Merge2Generator).isCompleted())[0];

                    if (Merge2.current.field.selectedUnit !== unit) {
                        Merge2.current.field.selectUnit(unit);
                    }

                    const speedUpButton = ComponentUtils.findChildByName(unitInfoView, "freeSpeedUpButton");
                    const force = cleverapps.clone(Forces.GENERATOR_SPEED_UP, true);
                    force.finger = { tap: speedUpButton };

                    this.force = Merge2TutorialHelper.createForce(speedUpButton, force, {
                        highlights: [unitInfoView],
                        importantNodes: [unitInfoView]
                    });

                    cleverapps.tutorial.on("unitSelectionChanged", this.finish.bind(this), this);
                    cleverapps.tutorial.on("onGeneratorRestored", this.finish.bind(this), this);
                    cleverapps.tutorial.on("onResize", this.finish.bind(this), this);
                },

                onFinish: function () {
                    this.force && this.force.hideForceHints();
                    Merge2.current.counter.trigger();
                }
            })
        ],

        isAvailable: function () {
            if (!Merge2.current
                || Merge2.current.mode !== Merge2.MODE_GAME
                || Merge2.current.counter.isActive()
                || cleverapps.forces.isShown(Forces.GENERATOR_SPEED_UP)) {
                return false;
            }

            return Merge2.current.field.listAvailableUnits({ type: "generator" })
                .filter((u) => {
                    const generator = u.findComponent(Merge2Generator);
                    return generator && generator.isCompleted() && generator.isRestorable();
                }).length > 0;
        }
    });
};

Merge2SpeedUpTutorial.NAME = "merge2_speed_up_tutorial";